import ScrollToTop from 'components/generic/router/ScrollToTop'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import Profile from '../Profile'
import PostScore from '../social-matches/PostScore'
import SubmissionSuccess from '../social-matches/SubmissionSuccess'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5'

import SwitchHashPaths from './SwitchHashPaths'
import HashPath from './HashPath'
import WinLossRatio from '../WinLossRatioComponentDisplay'

export enum PageUrls {
  Profile = '/',
}

export enum SubPaths {
  PostScore = '#post-score',
  SubmissionSuccess = '#post-score/success',
  WinLossRatio = '#win-loss',
}

interface Props {
  enableSelfSubmission?: boolean
  hideResultsForAnonUser?: boolean
}

const ProfileRouter = React.memo(({ enableSelfSubmission, hideResultsForAnonUser }: Props) => {
  return (
    <Router>
      <ScrollToTop />
      <QueryParamProvider adapter={ReactRouter5Adapter}>
        <SwitchHashPaths>
          <HashPath isDefault>
            <Profile
              enableSelfSubmission={enableSelfSubmission}
              hideResultsForAnonUser={hideResultsForAnonUser}
            />
          </HashPath>
          {enableSelfSubmission && [
            <HashPath hashPath={SubPaths.PostScore}>
              <PostScore />
            </HashPath>,
            <HashPath hashPath={SubPaths.SubmissionSuccess}>
              <SubmissionSuccess />
            </HashPath>,
          ]}
          <HashPath hashPath={SubPaths.WinLossRatio}>
              <WinLossRatio />
          </HashPath>,
        </SwitchHashPaths>
      </QueryParamProvider>
    </Router>
  )
})

export default ProfileRouter
